import type { SortMemberGroupColumn } from '@library/types/memberGroups';

export const DEFAULT_MEMBER_GROUP_SORT: SortMemberGroupColumn = {
  sortBy: 'name',
  sortDirection: 'asc'
};
